import { Radio } from "shared/components";
import { cx } from "shared/utils";

export const PmsSyncOption = ({
  value,
  onChange,
  className,
  name
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
  name: string;
}) => {
  return (
    <div className={cx("flex gap-4 mt-2", className)}>
      <Radio
        className="text-sm"
        label="Sync with PMS"
        id={`${name}-pms`}
        name={name}
        onChange={() => onChange(true)}
        checked={value}
      />
      <Radio
        className="text-sm"
        label="Edit manually"
        id={`${name}-manual`}
        name={name}
        onChange={() => onChange(false)}
        checked={!value}
      />
    </div>
  );
};
